import React, { Component } from "react";
import { Form, Input, Button, Card } from "antd";
import { validate } from "validate.js";
import { urlValidationRule } from "./validators";
import URLSchemaSelector from "../../URLSchemaSelector/URLSchemaSelector";

export default class TrackedWebsiteWizard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: "",
      validationError: "",
      urlSchema: "https://"
    };
  }

  handleSubmit = event => {
    event.preventDefault();
    let url = this.state.url;
    url = url.endsWith("/") ? url.slice(0, -1) : url;
    const urlSchema = this.state.urlSchema;
    let normalizedUrl = url.toLowerCase().trim();

    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      normalizedUrl = urlSchema.concat(url);
    }

    const validationError = validate({ url: normalizedUrl }, urlValidationRule);

    if (!validationError) {
      this.setState({ validationError: "" });
      this.props.onAddTrackedWebsite(normalizedUrl);
    } else {
      this.setState({ validationError: validationError.url });
    }
  };

  handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
      validationError: ""
    });
  };

  handleUrlSchema = urlSchema => {
    this.setState({ urlSchema });
  };

  render() {
    return (
      <Card>
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <Form.Item
            label="Website"
            validateStatus={this.state.validationError ? "error" : "validating"}
            help={this.state.validationError ? this.state.validationError : ""}>
            <Input
              type="text"
              addonBefore={<URLSchemaSelector onChange={this.handleUrlSchema} />}
              value={this.state.url}
              name="url"
              onChange={this.handleInputChange}
            />
          </Form.Item>
          <Form.Item>
            <Button data-cy="add-website" type="primary" htmlType="submit" loading={this.props.isAddingTrackedWebsite}>
              Add website
            </Button>
          </Form.Item>
        </Form>
      </Card>
    );
  }
}
